export default {
    error: {
        FIX_ALL_ERRORS: "por favor, corrija todos os erros e salve novamente",
        CONNECTION_TO_THE_SERVER: "não foi possível conectar ao servidor, verifique sua conexão e tente novamente",
        UNKNOWN_ERROR: "erro ao salvar o formulário, tente novamente",
        REQUIRED_FIELD: "este campo é obrigatório",

        INVALID_REQUEST: "requisião inválida",
        INTERNAL_SERVER_ERROR: "erro interno do servidor",
        RECAPTCHA_ERROR: "o token recaptcha está inválido, você é um robô?",

        COMPANY_NOT_FOUND: "código da empresa não encontrado",
        INCORRECT_USERNAME_PASSWORD: "usuário ou senha incorreta",
        BANNED_USER: "seu acesso está temporariamente bloqueado",
    },
    auth_login: {
        company_code: "Código da empresa",
        username: "Nome de usuário",
        password: "Senha",
        proceed: "CONTINUAR",
        sign_in: "ENTRAR",
        loading: "CARREGANDO...",
        forgot_password: "Esqueci minha senha",
        privacy_policy: "Política de Privacidade",
        privacy_policy_link: "https://www.google.com/intl/pt-BR/policies/privacy/",
        terms_of_service: "Termos de Serviço",
        terms_of_service_link: "https://www.google.com/intl/pt-BR/policies/terms/",
        recaptcha_warning: "Este site é protegido pelo reCAPTCHA e a {{0}} e os {{1}} do Google se aplicam."
    },
    common: {
        failed_retrieve_data_from_server: "Falha ao carregar dados do servidor.",
        try_again: "Tentar novamente",
        save_button: "Salvar",
        saving: "Salvando...",
        edit_button: "Editar",
        loading: "Carregando...",
        refresh_data: "Atualizar dados",
        delete_button: "Excluir",
        deleting: "Excluindo...",
    },
    breadcrumbs: {
        '404_error': 'Erro 404',
        login: 'Entrar',
        forgot_password: 'Esqueci minha senha',
        home: 'Foodsoft',
        dashboard: 'Painel de controle',
        order_listing: 'Pedidos',
        menu_listing: 'Cardápios',
        menu_form_new: 'Novo cardápio',
        menu_form_edit: 'Configurar cardápio',
        product_listing: 'Produtos',
        product_form_new: 'Novo produto',
        product_form_edit: 'Editar produto',
        product_category_form_new: 'Nova categoria',
        product_category_form_edit: 'Editar categoria',
        general_settings_form: 'Configurações gerais',
        printer_settings_form: 'Configurações de impressão',
        store_listing: 'Estabelecimentos',
        store_form_new: 'Novo estabelecimento',
        store_form_edit: 'Editar estabelecimento',
        staff_member_listing: 'Membros da equipe',
        staff_member_form_new: 'Novo membro da equipe',
        staff_member_form_edit: 'Editar membro da equipe',
        role_listing: 'Cargos',
        role_form_new: "Novo cargo",
        role_form_edit: "Editar cargo",
        reports_listing: "Relatórios",
        product_sales: "Venda de produtos"
    },
    navigation: {
        dashboard: "Painel de controle",
        orders: "Pedidos",
        menus: "Cardápios",
        reports: "Relatórios",
        product_sales: "Venda de produtos",
        visit_website: "Visite seu site",
        settings: "Configurações",
        company_data: "Dados da empresa",
        general_settings: "Configurações gerais",
        printer_settings: 'Config. de impressão',
        manage_stores: "Estabelecimentos",
        manage_staff: "Equipe",
        manage_roles: "Cargos",
        user: "Usuário",
        my_data: "Meus dados",
        logout: "Sair",
        help: "Ajuda",
    },
    state: {
        loading_message: "Carregando...",
        empty_message: "Nenhum resultado encontrado",
        request_error_message: "Falha ao carregar dados do servidor",
        try_again: "Tentar novamente",
    },
    footer: {
        copyright: "Copyright © {{age}} Stomp Tecnologia.",
    },
    not_found: {
        page_unavailable: "Desculpe, esta página não está disponível.",
        link_broken: "O link que você clicou pode estar quebrado, ou a página pode ter sido removida.",
        go_to_dashboard_link: "Voltar para o painel de controle",
    },
    input_image: {
        select_file: "Selecionar arquivo",
        browse: "Procurar",
        image_remove_btn: "Remover",
        adjust_image: "Ajustar imagem",
        ok_btn: "Salvar",
        rotate_90: "Rotacionar 90º",
        rotate_90_invert: "Rotacionar -90º",
    },
    general_settings: {
        display_name: "Nome de exibição",
        display_name_warning: "Como você identifica sua empresa",
        company_code: "Código da empresa",
        company_code_warning: "O código da empresa faz parte do endereço do seu cardápio online e também é necessário para você entrar no sistema",
        logo: "Logomarca",
        logo_description: "Envie sua logomarca com 512x512 pixels ou superior",
        language_code: "Idioma",
        "pt-BR": "Português (brasileiro)",
        "en-US": "Inglês",
        country_code: "País",
        BR: "Brasil",
        US: "Estados Unidos",
        facebook_link: "Facebook",
        instagram_link: "Instagram",
        themes: "Temas",
        theme_choose: "Escolher",
        facebook_pixel_id: "Pixel do Facebook (apenas o ID)",
        facebook_pixel_id_description: "O pixel do Facebook é uma ferramenta de análise que permite mensurar a eficácia da sua publicidade com base nas ações que as pessoas realizam no seu site.",
        timezone: "Fuso horário",
        timezone_description: "Listamos os códigos de fuso horário e quais estados os utilizam",
        "America/Noronha": "America/Noronha (Ilhas do Atlântico)",
        "America/Belem": "America/Belem (leste do Pará e Amapá)",
        "America/Fortaleza": "America/Fortaleza (MA, PI, CE, RN, PB)",
        "America/Recife": "America/Recife (Pernambuco)",
        "America/Araguaina": "America/Araguaina (Tocantins)",
        "America/Maceio": "America/Maceio (Alagoas, Sergipe)",
        "America/Bahia": "America/Bahia (Bahia)",
        "America/Sao_Paulo": "America/Sao_Paulo (GO, DF, MG, ES, RJ, SP, PR, SC, RS)",
        "America/Campo_Grande": "America/Campo_Grande (Mato Grosso do Sul)",
        "America/Cuiaba": "America/Cuiaba (Mato Grosso)",
        "America/Santarem": "America/Santarem (Oeste do Pará)",
        "America/Porto_Velho": "America/Porto_Velho (Rondônia)",
        "America/Boa_Vista": "America/Boa_Vista (Roraima)",
        "America/Manaus": "America/Manaus (leste do Amazonas)",
        "America/Eirunepe": "America/Eirunepe (oeste do Amazonas)",
        "America/Rio_Branco": "America/Rio_Branco (Acre)",
    },
    printer_settings: {
        printer: "Impressora",
        printer_description: "Compatível apenas com impressoras térmicas",
        have_guillotine: "Impressora possui guilhotina?",
        cut_paper_yes: "Sim",
        cut_paper_no: "Não",
        failed_retrieve_printers: "Falha ao carregar impressoras térmicas.",
        connection: "Conexão",
        printer_adapter_navigatorusb: "USB (navegadores compatíveis)",
        printer_adapter_printerws: "Printer Connect",
    },
    store_listing: {
        new_button: "Novo estabelecimento",
        delete_store_confirm: "Você tem certeza que deseja excluir permanentemente o estabelecimento \"{{name}}\"?"
    },
    store_form: {
        name: "Nome do estabelecimento",
        menu: "Cardápio",
        phone: "WhatsApp",
        store_code: "Código do estabelecimento",
        warning_store_code: "Este código fará parte do link do estabelecimento, mas só ficará visível se houver dois ou mais estabelecimentos cadastrados.",
        preparation_time: "Tempo de preparo",
        preparation_time_append_text: "minutos",
        preparation_time_description: "Preencha este campo em minutos",
        accept_delivery_order: "Aceitar pedidos delivery",
        accept_delivery_order_yes: "Sim",
        accept_delivery_order_no: "Não",
        accept_pickup_order: "Aceitar pedidos de retidada",
        accept_pickup_order_yes: "Sim",
        accept_pickup_order_no: "Não",
        payment_methods: "Métodos de pagamento",
        payment_methods_options: "Opções",
        payment_method_add: "Adicionar",
        payment_method_remove: "Remover",
        payment_method_price_change_option: "Alteração do preço",
        payment_method_price_change_option_no_change: "Sem alteração do preço",
        payment_method_price_change_option_fixed_discount: "Desconto fixo",
        payment_method_price_change_option_percentage_discount: "Desconto percentual",
        payment_method_price_change_option_fixed_increase: "Acréscimo fixo",
        payment_method_price_change_option_percentage_increase: "Acréscimo percentual",
        payment_method_name: "Método de pagamento",
        payment_method_ask_need_change: "Perguntar se precisa de troco",
        payment_method_ask_need_change_no: "Não",
        payment_method_ask_need_change_yes: "Sim",
        payment_method_fixed_price_increase: "Valor",
        payment_method_percentage_price_increase: "Percentual",
        delivery_fee: "Taxa de entrega",
        delivery_fee_type: "Opções",
        FIXED: "Taxa fixa",
        TO_BE_NEGOTIATED: "À negociar",
        BY_NAMED_AREA: "Por bairro",
        delivery_fee_fixed: "Valor da taxa",
        delivery_named_areas: "Bairros",
        delivery_named_area_name: "Nome",
        delivery_named_area_price: "Valor da taxa",
        delivery_named_area_add: "Adicionar",
        delivery_named_area_remove: "Remover",
        free_delivery_starting_from: "Entrega grátis a partir de",
        free_delivery_starting_from_description: "Preencha com zero para não oferecer entrega grátis a partir de um determinado valor",
        minimum_order_value: "Valor mínimo do pedido",
        address: "Endereço",
        address_line1: "Rua",
        address_house_number: "Número",
        address_line2: "Complemento",
        address_level3: "Bairro",
        postal_code: "CEP",
        address_level2: "Cidade",
        address_level1: "Estado",
        opening_hours: "Horário de funcionamento",
        sunday: "Domingo",
        monday: "Segunda-feira",
        tuesday: "Terça-feira",
        wednesday: "Quarta-feira",
        thursday: "Quinta-feira",
        friday: "Sexta-feira",
        saturday: "Sábado",
        opening_hours_from: "Abre às",
        opening_hours_to: "Fecha às",
        opening_hours_add: "Adicionar",
        opening_hours_remove: "Remover"
    },
    role_listing: {
        new_button: "Novo cargo",
        status: "Status",
    },
    role_form: {
        name: "Nome",
        permissions: "Permissões",
    },
    role_permissions: {
        roles: "Cargos",
        view_roles: "Ver cargos",
        edit_roles: "Editar cargos",
        staff_members: "Membros da equipe",
        view_staff_members: "Ver membros da equipe",
        edit_staff_members: "Editar membros da equipe",
        products: "Produtos",
        view_products: "Ver produtos",
        edit_products: "Editar produtos",
        product_categories: "Categorias de produtos",
        view_product_categories: "Ver categorias de produtos",
        edit_product_categories: "Editar categorias de produtos",
        company: "Empresa",
        view_company: "Ver configurações gerais",
        edit_company: "Editar configurações gerais",
        view_stores: "Ver estabelecimentos",
        edit_stores: "Editar estabelecimentos"
    },
    staff_member_listing: {
        new_button: "Novo membro",
        role: "Cargo",
        error_load_roles: "Erro ao carregar cargos",
        all_roles: "Todos os cargos",
        search: "Pesquisar",
        search_placeholder: "CPF ou e-mail",
        search_button: "Pesquisar",
        ban_button: "Banir",
        banning: "Banindo...",
        revoke_ban_button: "Revogar banimento",
        revoking_ban: "Revogando...",
        status: "Status",
        status_banned: "Banido",
        status_not_banned: "Ativo",
    },
    staff_member_form: {
        name: "Nome",
        role: "Cargo",
        tax_number: "CPF",
        birth_date: "Data de nascimento",
        email: "E-mail",
        phone: "Telefone",
        username: "Nome de usuário",
        new_password: "Nova senha",
        note: "Observação",
        note_description: "Você pode inserir informações adicionais aqui",
        validation_password_required: "a senha é necessária se você estiver criando um nome de usuário",
    },
    product: {
        choice_type_options_multiple_choice: "Opções de múltipla escolha",
        choice_type_options_single_choice: "Opções de escolha única",
        choice_type_options_repeatable_choice: "Opções de escolhas repetíveis",
        choice_type_text: "Texto",
    },
    product_listing: {
        new_category_button: "Nova categoria",
        new_product_button: "Novo produto",
        reorder_categories: "Reordenar categorias",
        reorder_categories_ok: "Salvar ordem",
        reorder_categories_saving: "Salvando...",
        reorder_products: "Reordenar produtos",
        reorder_ok: "Salvar",
        reorder_saving: "Salvando...",
        edit_category: "Editar categoria",
        delete_category: "Excluir categoria",
        product_status: "Status",
        status_disabled: "Desabilitado",
        status_enabled: "Habilitado",
        enable_button: "Habilitar",
        enabling: "Habilitando...",
        disable_button: "Desabilitar",
        disabling: "Desabilitando...",
        delete_product_category_confirm: "Você tem certeza que deseja excluir permanentemente a categoria \"{{name}}\"? (apenas categorias vazias podem ser excluídas)",
        delete_product_confirm: "Você tem certeza que deseja excluir permanentemente o produto \"{{name}}\"?",
        clone_button: "Duplicar",
        cloning: "Duplicando...",
        cloned_product_suffix: " (cópia)"
    },
    product_form: {
        name: "Nome",
        product_category: "Categoria",
        price: "Preço",
        photo: "Foto",
        photo_description: "Enviar imagem com 592x333 pixels ou superior",
        description: "Descrição",
        description_details: "Descreva os produtos em detalhes para ajudar o cliente a escolher",
        choices: "Escolhas personalizadas",
        choice_empty_title: "Escolha sem título",
        reorder_choices: "Reordenar escolhas",
        reorder_choices_ok: "OK",
        choice_add: "Adicionar nova escolha",
        no_choice_message: "Nenhuma escolha personalizada foi criada para este produto ainda.",
        choice_title: "Título",
        choice_type: "Tipo",
        choice_min_options: "Qtd. mínima de opções",
        choice_max_options: "Qtd. máxima de opções",
        charge_only_most_expensive_option_label: "Cobrança das opções",
        charge_only_most_expensive_option_description: "Aplicável quando o preço adicional é preenchido",
        charge_only_most_expensive_option_no: "Somar o preço das opções escolhidas (padrão)",
        charge_only_most_expensive_option_yes: "Cobrar apenas a opção escolhida mais cara",
        choice_required: "Obrigatório",
        required: "Obrigatório",
        not_required: "Opcional",
        choice_note: "Observações",
        choice_remove: "Excluir escolha",
        choice_options: "Opções",
        choice_option_empty_description: "Opção sem descrição",
        reorder_choice_options: "Reordenar opções",
        reorder_choice_options_ok: "OK",
        choice_option_add: "Adicionar nova opção",
        no_choice_option_message: "Nenhuma opção foi criada para esta escolha personalizada ainda.",
        choice_option_description: "Descrição",
        choice_option_price: "Preço adicional",
        choice_option_details: "Detalhes",
        choice_option_remove: "Excluir opção",
    },
    product_category_form: {
        name: "Nome",
    },
    menu_listing: {
        new_button: "Novo cardápio",
        edit_button: "Configurar",
        products_button: "Editar",
        delete_menu_confirm: "Você tem certeza que deseja excluir permanentemente o cardápio \"{{name}}\"? (apenas cardápios vazios podem ser excluídos)"
    },
    menu_form: {
        name: "Nome do cardápio"
    },
    order_listing: {
        new_button: "Novo pedido",
        store: "Estabelecimento",
        auto_printing_switch: "Impressão automática",
        error_load_stores: "Erro ao carregar estabelecimentos",
        customer_name: "Cliente",
        address_level3: "Bairro",
        items_count: "Itens",
        total: "Total",
        show_order_button: "Exibir",
        print_order_button: "Imprimir",
        printing: "Imprimindo...",
        PRINTING_ERROR: "Erro ao imprimir pedido.",
        sequential_number: "Sequencial",
        order_type: "Tipo",
        order_type_DELIVERY: "Delivery",
        order_type_PICKUP: "Retirada",
        order_header: "Pedido",
    },
    product_sales_report: {
        product_sales_report: "Relatório de venda de produtos",
        periodicity: "Periodicidade",
        daily: "Diário"
    }
}
